import { faDotCircle, faTimes } from '@fortawesome/free-solid-svg-icons'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { Draggable } from 'react-beautiful-dnd'
import { RouteListItemStyled } from './route-list-item.styled'
import { connect } from 'react-redux'
import { removePoint } from '../../../state/path/path.actions'
import { setActivePoint } from '../../../state/ui/ui.actions'
import { createStructuredSelector } from 'reselect'
import {
  selectActivePoint,
  selectDraggedPoint,
} from '../../../state/ui/ui.selectors'

const RouteListItemComponent = (props: any) => {
  const id = `${props.coordinate[0]}-${props.coordinate[1]}`

  const handleDelete = () => {
    props.removePoint(props.index)
    props.setActive(undefined)
  }

  return (
    <Draggable
      key={id}
      draggableId={props.index.toString()}
      index={props.index}
    >
      {(provided) => (
        <RouteListItemStyled>
          <li
            {...provided.dragHandleProps}
            {...provided.draggableProps}
            ref={provided.innerRef}
            className={`${props.activePoint === props.index && 'active'}`}
            onMouseEnter={() => props.setActive(props.index)}
            onMouseLeave={() => props.setActive(undefined)}
          >
            <span
              className={`bullet ${
                (props.index === 0 || props.index === props.draggedPoint) &&
                'start'
              } ${
                (props.index === props.length - 1 ||
                  props.index === props.draggedPoint) &&
                'end'
              }`}
            >
              <FontAwesomeIcon icon={faDotCircle} className='icon' />
            </span>
            <label>
              <span className='text'>Waypoint</span>
              <span className='number'>{props.index + 1}</span>
            </label>
            <button className='delete-btn' onClick={handleDelete}>
              <FontAwesomeIcon icon={faTimes} />
            </button>
          </li>
        </RouteListItemStyled>
      )}
    </Draggable>
  )
}

const stateProps = createStructuredSelector({
  activePoint: selectActivePoint,
  draggedPoint: selectDraggedPoint,
})

const dispatchProps = {
  removePoint: removePoint,
  setActive: setActivePoint,
}

export const RouteListItem = connect(
  stateProps,
  dispatchProps
)(RouteListItemComponent)
